// Source: https://play.tailwindcss.com/faQEiRVkjv
module.exports = () => ({
  "label .switch": {
    "@apply ds-align-middle ds-mr-sm ds-mt-2xs ds-top-[-4px]": true,
  },
  ".switch": {
    // TODO (stefan):
    // Reverting back change that should align label with right side of checkbox/switch.
    // This caused issues with alignment when inputs are listed after each other and with the label and the center
    // of the checkbox/switch.
    // "@apply ds-relative ds-appearance-none ds-w-3xl ds-h-xl ds-rounded-2xl ds-float-left": true,
    "@apply ds-relative ds-appearance-none ds-w-3xl ds-h-xl ds-rounded-2xl ds-opacity-100": true,
  },
  ".switch::before": {
    content: '""',
    transition: "right 150ms",
    right: "calc(100% - 28px)",
    "@apply ds-absolute ds-block ds-bg-primary-white ds-rounded-2xl ds-border-[3px] ds-h-xl ds-w-xl": true,
  },
  ".switch.indeterminate::before": { right: "calc(50% - 14px)" },
  ".switch:not(:checked)": { "@apply ds-bg-tertiary-lightgrey": true },
  ".switch:not(:checked)::before": {
    "@apply ds-border-tertiary-lightgrey": true,
  },
  ".switch:not(:checked, :disabled):hover,\n.switch:not(:checked, :disabled).hover": {
    "@apply ds-ring-primary-black ds-outline-none ds-ring-4 ds-ring-opacity-5": true,
  },
  ".switch:not(:checked, :disabled):focus,\n.switch:not(:checked, :disabled).focus": {
    "@apply ds-ring-primary-black ds-outline-none ds-ring-4 ds-ring-opacity-10": true,
  },
  ".switch:not(:checked, :disabled):active,\n.switch:not(:checked, :disabled).active": {
    "@apply ds-ring-primary-black ds-outline-none ds-ring-4 ds-ring-opacity-[0.15]": true,
  },
  ".switch:not(:checked):disabled": {
    "@apply ds-bg-tertiary-lightergrey ds-cursor-not-allowed": true,
  },
  ".switch:not(:checked):disabled::before": {
    "@apply ds-border-tertiary-lightergrey": true,
  },
  ".switch:checked": { "@apply ds-bg-primary-blue": true },
  ".switch:checked::before": {
    "@apply ds-right-0 ds-border-primary-blue": true,
  },
  ".switch:checked:not(:disabled):hover,\n.switch:checked:not(:disabled).hover": {
    "@apply ds-ring-primary-blue ds-outline-none ds-ring-4 ds-ring-opacity-10": true,
  },
  ".switch:checked:not(:disabled):focus,\n.switch:checked:not(:disabled).focus": {
    "@apply ds-ring-primary-blue ds-outline-none ds-ring-4 ds-ring-opacity-20": true,
  },
  ".switch:checked:not(:disabled):active,\n.switch:checked:not(:disabled).active": {
    "@apply ds-ring-primary-blue ds-outline-none ds-ring-4 ds-ring-opacity-30": true,
  },
  ".switch:checked:disabled": {
    "@apply ds-bg-tertiary-lightgrey ds-cursor-not-allowed": true,
  },
  ".switch:checked:disabled::before": {
    "@apply ds-border-tertiary-lightergrey": true,
  },
  ".switch.invalid": { "@apply ds-bg-secondary-red": true },
  ".switch.invalid::before": { "@apply ds-border-secondary-red": true },
  ".switch.invalid:not(:disabled):hover,\n.switch.invalid:not(:disabled).hover": {
    "@apply ds-ring-secondary-red ds-outline-none ds-ring-4 ds-ring-opacity-10": true,
  },
  ".switch.invalid:not(:disabled):focus,\n.switch.invalid:not(:disabled).focus": {
    "@apply ds-ring-secondary-red ds-outline-none ds-ring-4 ds-ring-opacity-20": true,
  },
  ".switch.invalid:not(:disabled):active,\n.switch.invalid:not(:disabled).active": {
    "@apply ds-ring-secondary-red ds-outline-none ds-ring-4 ds-ring-opacity-30": true,
  },
  ".switch.invalid:disabled": {
    "@apply ds-bg-tertiary-lightgrey ds-cursor-not-allowed": true,
  },
  ".switch.invalid:disabled::before": {
    "@apply ds-border-tertiary-lightergrey": true,
  },
});
